const buildQuery = function(queryObj, prefix = '') {
    if(!queryObj instanceof Object) {
        throw new Error('Parameter property is not an Object');
    }
    const params = [];
    for (let query in queryObj) {
        params.push(encodeURI(query + "=" + queryObj[query]));
    };

    return prefix + params.join("&");
};

const request = function(method, uri, params) {
    var promise = new Promise( function (resolve, reject) {

        var http = new XMLHttpRequest();
        
        uri = encodeURI(uri);

        if(params && method === 'GET'){
            uri = uri + buildQuery(params, '?');
        }

        http.open(method, uri);

        if (method === 'POST') {
            http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            http.send(buildQuery(params));
        } else {
            http.send();
        }

        http.onload = function() {
            if (/20\d/.test(this.status)) {
                const res = this.responseText;
                //If the returned data is JSON parse it as such
                let isJson = (/^{.+:.+,*}$/g.test(res));
                resolve(isJson ? JSON.parse(res) : res);
            } else {
                reject(this.statusText);
            }
        };

        http.onerror = function() {
            reject(this.statusText);
        };
    });
    return promise;
};

var ajax = {
    get: function(uri, params) {
        return request('GET', uri, params);
    },

    post: function(uri, params) {
        return request('POST', uri, params);
    }, 
};

export default ajax;